import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    status: 'idle',
    error: null,
}

const authSlice = createSlice({
    name: 'auth',
    initialState,
    reducers: {
        setAuthSucceeded: (state) => {
            state.status = 'succeeded';
        },
        setAuthLoading: (state) => {
            state.status = 'loading';
        },
        setAuthError: (state, action) => {
            state.status = 'failed';
            state.error = action.payload;
        }
    },
});


export const { 
  setTelegramData, 
  setAuthSucceeded, 
  setAuthLoading, 
  setAuthError,
  logout 
} = authSlice.actions;

export default authSlice.reducer;
